/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Practice_HubInputs */

const en_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice Hub`)
};

const es_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de práctica`)
};

const de_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungszentrum`)
};

const zh_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习中心`)
};

const ar_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز التدريب`)
};

const fr_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de pratique`)
};

const vi_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trung tâm luyện tập`)
};

const sw_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitovu cha Mazoezi`)
};

const th_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ศูนย์ฝึกซ้อม`)
};

const bs_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centar za vježbanje`)
};

const ja_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`練習センター`)
};

const ko_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습 센터`)
};

const pt_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central de prática`)
};

const it_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro di allenamento`)
};

const sv_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Träningscenter`)
};

const nl_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefencentrum`)
};

const da_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træningscenter`)
};

const nb_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningssenter`)
};

const fi_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoituskeskus`)
};

const pl_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum treningowe`)
};

const ru_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренировочный центр`)
};

const tr_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman Merkezi`)
};

const hi_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास केंद्र`)
};

const id_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Latihan`)
};

const ms_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hab Latihan`)
};

const cs_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tréninkové centrum`)
};

const el_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κέντρο εξάσκησης`)
};

const he_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרכז תרגול`)
};

const af_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefensentrum`)
};

const hu_nav_practice_hub = /** @type {(inputs: Nav_Practice_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlóközpont`)
};

/**
* | output |
* | --- |
* | "Practice Hub" |
*
* @param {Nav_Practice_HubInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_practice_hub = /** @type {((inputs?: Nav_Practice_HubInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Practice_HubInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_practice_hub(inputs)
	if (locale === "de") return de_nav_practice_hub(inputs)
	if (locale === "zh") return zh_nav_practice_hub(inputs)
	if (locale === "ar") return ar_nav_practice_hub(inputs)
	if (locale === "fr") return fr_nav_practice_hub(inputs)
	if (locale === "vi") return vi_nav_practice_hub(inputs)
	if (locale === "sw") return sw_nav_practice_hub(inputs)
	if (locale === "th") return th_nav_practice_hub(inputs)
	if (locale === "bs") return bs_nav_practice_hub(inputs)
	if (locale === "ja") return ja_nav_practice_hub(inputs)
	if (locale === "ko") return ko_nav_practice_hub(inputs)
	if (locale === "pt") return pt_nav_practice_hub(inputs)
	if (locale === "it") return it_nav_practice_hub(inputs)
	if (locale === "sv") return sv_nav_practice_hub(inputs)
	if (locale === "nl") return nl_nav_practice_hub(inputs)
	if (locale === "da") return da_nav_practice_hub(inputs)
	if (locale === "nb") return nb_nav_practice_hub(inputs)
	if (locale === "fi") return fi_nav_practice_hub(inputs)
	if (locale === "pl") return pl_nav_practice_hub(inputs)
	if (locale === "ru") return ru_nav_practice_hub(inputs)
	if (locale === "tr") return tr_nav_practice_hub(inputs)
	if (locale === "hi") return hi_nav_practice_hub(inputs)
	if (locale === "id") return id_nav_practice_hub(inputs)
	if (locale === "ms") return ms_nav_practice_hub(inputs)
	if (locale === "cs") return cs_nav_practice_hub(inputs)
	if (locale === "el") return el_nav_practice_hub(inputs)
	if (locale === "he") return he_nav_practice_hub(inputs)
	if (locale === "af") return af_nav_practice_hub(inputs)
	if (locale === "hu") return hu_nav_practice_hub(inputs)
	return en_nav_practice_hub(inputs)
});